<template>
  <div class="body d-flex pb-3">
    <div class="container-xxl card">
      <div class="row align-items-center">
        <div class="border-0 mb-4">
          <div
            class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap"
          >
            <h3 class="fw-bold mb-0">İstifadəçilər</h3>
            <div class="col-auto d-flex w-sm-100">
              <button
                type="button"
                @click.prevent="toAddUser"
                class="btn btn-primary btn-set-task w-sm-100"
                data-bs-toggle="modal"
                data-bs-target="#expadd"
              >
                <i class="icofont-plus-circle me-2 fs-6"></i>Əlavə et
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Row end  -->
      <div class="row mb-3">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div
                id="patient-table_wrapper"
                class="dataTables_wrapper dt-bootstrap5 no-footer"
              >
                <div class="row overflow-auto">
                  <div class="col-sm-12">
                    <table
                      id="patient-table"
                      class="table table-striped align-middle mb-0 nowrap dataTable no-footer dtr-inline"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="patient-table_info"
                    >
                      <thead>
                        <tr role="row">
                          <th class="">Partner</th>
                          <th class="">Password</th>
                          <th class="">shortNumbers</th>
                          <th class="">clientIps</th>
                          <th class="">operatorChannels</th>
                          <th class="">smsBalance</th>
                          <th class="">smsFee</th>
                          <th class="">Status</th>
                          <th class="">Redaktə</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in items" :key="item.id" class="">
                          <td>{{ item.partnerId }}</td>
                          <td>{{ item.password }}</td>
                          <td>
                            <ul>
                              <li
                                v-for="(item, i) in item.shortNumbers"
                                :key="i"
                              >
                                {{ item[0] }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul>
                              <li v-for="(item, i) in item.clientIps" :key="i">
                                {{ item }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul>
                              <li
                                v-for="(item, i) in item.operatorChannels"
                                :key="i"
                              >
                                {{ item }}
                              </li>
                            </ul>
                          </td>
                          <td>{{ item.smsBalance }}</td>
                          <td>{{ item.smsFee }}</td>
                          <td v-if="item.isActive">Aktiv</td>
                          <td v-else>Deaktiv</td>
                          <td>
                            <div class="d-flex gap-2 align-items-center">
                              <!-- Update -->
                              <button
                                type="button"
                                class="btn btn-outline-secondary"
                                @click="toUpdateUser(item)"
                              >
                                <i class="icofont-edit text-success"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary"
                                @click="toDeleteTemplate(item)"
                              >
                                <i class="icofont-ui-delete text-danger"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary"
                                @click="askRemoveToken(item.id)"
                              >
                                <i class="icofont-key text-warning"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <br />
                <pagination
                  :totalPages="leng"
                  :perPage="request.pageSize"
                  :currentPage="request.currentPage"
                  @pagechanged="onPageChange"
                />
                <modal
                  name="delete"
                  :widht="800"
                  height="auto"
                  styles="background-color: transparent;"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="expeditLabel">
                          Silmək istədiyinizə əminsiz?
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          @click="$modal.hide('delete')"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="remove"
                          data-bs-dismiss="modal"
                        >
                          Bəli
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="$modal.hide('delete')"
                        >
                          Xeyr
                        </button>
                      </div>
                    </div>
                  </div>
                </modal>
                <!-- Token silmək üçün modal -->
                <modal
                  name="deleteToken"
                  :width="800"
                  height="auto"
                  styles="background-color: transparent;"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title fw-bold">
                          Token silmək istədiyinizə əminsiz?
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          @click="$modal.hide('deleteToken')"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmRemoveToken"
                        >
                          Bəli
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="$modal.hide('deleteToken')"
                        >
                          Xeyr
                        </button>
                      </div>
                    </div>
                  </div>
                </modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jwtInterceptor from "../../jwt.interceptor";
import Pagination from "../parts/site/Pagination.vue";
import store from "../../store";
import user from "../../store/user";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "User",
  components: {
    Pagination,
  },
  data: () => ({
    loading: true,
    searchloading: false,
    // exportloading: false,
    request: {
      pageNumber: 1,
      pageSize: 10,
    },
    totalCount: 0,
    leng: 0,
    roles: [
      { name: "Admin", id: "admin" },
      { name: "SuperAdmin", id: "superadmin" },
    ],
    clinics: [],
    specialities: [],
    items: [],
    tokenToRemove: null,
  }),
  methods: {
    searchUsers() {
      this.$router.push("/users");
    },
    toAddUser() {
      this.$router.push("/addUser");
    },
    toUpdateUser(item) {
      user.dispatch("prepareUserUpdate", item);
      this.$router.push("/updateUser");
    },
    toDeleteTemplate(template) {
      this.rmelm = template.id;
      this.$modal.show("delete");
    },
    askRemoveToken(userId) {
      this.tokenToRemove = userId;
      this.$modal.show("deleteToken");
    },
    confirmRemoveToken() {
      jwtInterceptor
        .put(
          this.$store.getters.getUrl +
            "/Users/secretKey/remove/" +
            this.tokenToRemove
        )
        .then(() => {
          this.$toast.success("Token silindi", { position: "top-left" });
          this.refresh();
        })
        .catch(() => {
          this.$toast.error("Token silinmədi!", { position: "top-right" });
        });
      this.$modal.hide("deleteToken");
    },
    remove() {
      jwtInterceptor
        .delete(this.$store.getters.getUrl + "/Users/" + this.rmelm)
        .then((response) => {
          this.refresh();
          this.$toast.success("Silindi", {
            position: "top-left",
          });
          this.$modal.hide("delete");
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Xəta baş verdi!", {
            position: "top-right",
          });
        });
    },
    onPageChange(page) {
      this.request.pageNumber = page;
      this.refresh();
    },
    refresh() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Users", {
          params: this.request,
        })
        .then((response) => {
          this.items = response.data.result.items;
          this.totalCount = response.data.result.totalCount;
          this.leng = response.data.result.totalPages;
          this.searchloading = false;
        })
        .catch((error) => {
          console.log(error);
          this.searchloading = false;
          this.$toast.error("Xəta baş verdi!", {
            position: "top-right",
          });
        });
    },
  },
  created() {
    this.refresh();
  },
};
</script>

<style>
[data-theme="high-contrast"] {
  .table-striped > tbody > tr:nth-of-type(odd) > * {
    color: white !important;
  }
}
</style>
